import React from 'react'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from '@mui/material'

export default class HardwareLogFormSuccessModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        disableEscapeKeyDown
        aria-labelledby="form-dialog-title"
      >
        {this.props.eventsMessage === '' ||
        this.props.eventsMessage === undefined ? (
          <div>
            <DialogContent>
              <LinearProgress color="success" />
            </DialogContent>
          </div>
        ) : (
          <div>
            <DialogTitle>{this.props.title}</DialogTitle>
            <DialogContent>
              <div>
                <div style={{ paddingBottom: '10px' }}>
                  {this.props.eventsMessage.includes('•')
                    ? this.props.eventsMessage
                        .split('•')
                        .filter((error) => error.trim())
                        .map((error, index) => (
                          <div
                            key={index}
                            style={{
                              marginBottom:
                                index ===
                                this.props.eventsMessage
                                  .split('•')
                                  .filter((error) => error.trim()).length -
                                  1
                                  ? '0'
                                  : '8px',
                            }}
                          >
                            • {error.trim()}
                          </div>
                        ))
                    : this.props.eventsMessage}
                </div>
                <Button variant="contained" onClick={this.props.handleClose}>
                  OK
                </Button>
              </div>
            </DialogContent>
          </div>
        )}
      </Dialog>
    )
  }
}
